import { useTranslation } from 'next-i18next';
import { ReactElement } from 'react';
import * as React from 'react';
import { Offline } from 'react-detect-offline';

import { Typography } from '@/shared/components/atoms';

export default function OfflineShape(): ReactElement {
  const { t } = useTranslation('common');

  return (
    <div className=' text-center'>
      <Offline
        polling={{
          interval: 8000,
          timeout: 8000,
          enabled: true,
          url: 'https://ipv4.icanhazip.com',
        }}
      >
        <Typography
          className='inline-block rounded-xl bg-background-neutral-100 p-2'
          variant='caption'
        >
          {t('offline')}
        </Typography>
      </Offline>
    </div>
  );
}
